import React from 'react';
import { Modal } from 'react-bootstrap';

// Services
import InstructorService from 'services/InstructorService';
import EmailTypeService from 'services/EmailTypeService';

// Components
import Loader from 'components/common/Loader';

//-------------------------------------------------------------------------------------------------------------------

class EmailSettingsModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    show(opts) {
        return new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.setState({
                isOpen: true,
                isLoading: true,
                instructorID: opts.instructorID,
                courseID: opts.courseID,
                certID: opts.certID
            }, () => {
                this.load();
            });
        });
    }

    async load() {
        const { instructorID, courseID, certID } = this.state;
        this.setState({ isLoading: true });
        let emailTypes = await EmailTypeService.list();
        emailTypes = emailTypes.filter(et =>
            et.isInstructorCredentialsEmail && 
            (
                (!!courseID && et.isApplicableToCourses) || (!!certID && et.isApplicableToCerts)
            )
        );
        const settings = await InstructorService.getEmailSettings({ instructorID, courseID, certID });
        this.setState({
            isLoading: false,
            emailTypes,
            settings
        });
    }

    close() {
        this.setState({ isOpen: false });
    }
    
    async saveAndClose() {
        const { instructorID, courseID, certID, settings } = this.state;
        this.setState({ isLoading: true });
        await InstructorService.saveEmailSettings({
            instructorID, courseID, certID, settings
        });
        this.setState({ isLoading: false });
        this.close();
        this.resolve();
    }

    updateSetting(emailTypeID, values) {
        const { instructorID, courseID, certID } = this.state;
        const settings = [...this.state.settings];
        let index = settings.findIndex(s => s.emailTypeID == emailTypeID);
        if (index == -1) {
            settings.push({
                instructorID,
                courseID,
                certID,
                emailTypeID
            });
            index = settings.length - 1;
        }
        for (let fieldName in values) {
            const value = values[fieldName];
            settings[index][fieldName] = value;
        }
        this.setState({ settings });
    }

    toggleAll(isEnabled) {
        const { instructorID, courseID, certID } = this.state;
        const settings = [...this.state.settings];
        this.state.emailTypes.forEach(et => {
            let index = settings.findIndex(s => s.emailTypeID == et.id);
            if (index == -1) {
                settings.push({
                    instructorID,
                    courseID,
                    certID,
                    emailTypeID: et.id
                });
                index = settings.length - 1;
            }
            settings[index].behaviour = (isEnabled ? null : 'Skip');
        });
        this.setState({ settings });
    }

    //------------------------------------------------------------------------------

    render() {
        const {
            isOpen,
            isLoading
        } = this.state;

        if (!isOpen) {
            return null;
        }

        return (
            <Modal show className="instructor-email-settings-modal">
                {isLoading ? <Modal.Body><Loader /></Modal.Body> : this.renderInner()}
            </Modal>
        );
    }

    renderInner() {
        const {
            emailTypes,
            settings
        } = this.state;
        const areAllEnabled = emailTypes.every(et => {
            const setting = settings.find(s => s.emailTypeID == et.id);
            return !setting || setting.behaviour != 'Skip';
        });
        
        return (<>
            <Modal.Body>

                <table className="table table-bordered mb-0 email-types-table">
                    <thead>
                        <tr>
                            <th className="email-type-col">Email type</th>
                            <th className="send-col">Send</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="all-row">
                            <td className="email-type-col">
                                Enable / Disable all
                            </td>
                            <td className="send-col">
                                <input
                                    type="checkbox"
                                    checked={areAllEnabled}
                                    onChange={e => this.toggleAll(e.target.checked)}
                                />
                            </td>
                        </tr>
                        {emailTypes.map(et => {
                            const setting = settings.find(s => s.emailTypeID == et.id) || {};

                            return (
                                <tr key={et.id}>
                                    <td className="email-type-col">{et.name}</td>
                                    <td className="send-col">
                                        <input
                                            type="checkbox"
                                            checked={setting.behaviour != 'Skip'}
                                            onChange={e => this.updateSetting(et.id, { behaviour: (e.target.checked ? '' : 'Skip') })}
                                        />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-secondary me-auto" onClick={e => this.close()}>
                    Cancel
                </button>
                <button type="button" className="btn btn-primary ms-auto" onClick={e => this.saveAndClose()}>
                    Save
                </button>
            </Modal.Footer>
        </>);
    }

}

export default EmailSettingsModal;